import React, { Component } from "react";
import Collapse from "./Collapse";

class ServiceBookings extends Component {
  state = {};
  render() {
    return <Collapse></Collapse>;
  }
}

export default ServiceBookings;



// WEBPACK FOOTER //
// ./src/views/BookedServices/ServiceBookings/ServiceBookings.jsx